import { componentSizes } from '@/theme/componentSizes';
import { s, tableTokens } from '@/theme/tokens';
import type { SxProps, Theme } from '@mui/material/styles';

export const dataGridChromeSx: SxProps<Theme> = {
  '& .MuiDataGrid-columnHeader': {
    px: s(tableTokens.cellPadding.x),
    py: s(tableTokens.cellPadding.y),
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiDataGrid-cell': {
    px: s(tableTokens.cellPadding.x),
    py: s('none'),
    display: 'flex',
    alignItems: 'flex-start',
    boxSizing: 'border-box',
  },
  '& .MuiDataGrid-columnHeaderDraggableContainer': {
    paddingLeft: s(tableTokens.cellPadding.x),
    paddingRight: s(tableTokens.cellPadding.x),
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    paddingLeft: s(tableTokens.cellPadding.x),
    paddingRight: s(tableTokens.cellPadding.x),
  },
  '& .MuiDataGrid-columnHeaderTitleContainerContent': {
    paddingLeft: s('xxs'),
    paddingRight: s('xxs'),
  },
  '& .MuiDataGrid-cellContent': {
    display: 'flex',
    alignItems: 'flex-start',
    height: '100%',
    width: '100%',
    minWidth: 0,
    flex: '1 1 auto',
    paddingLeft: s(tableTokens.cellPadding.x),
    paddingRight: s(tableTokens.cellPadding.x),
    paddingTop: s('xs'),
    boxSizing: 'border-box',
  },
  '& .MuiDataGrid-footerContainer': {
    minHeight: `${componentSizes.dataGrid.footerHeight}px`,
    height: `${componentSizes.dataGrid.footerHeight}px`,
    maxHeight: `${componentSizes.dataGrid.footerHeight}px`,
    paddingLeft: s('xxs'),
    paddingRight: s('none'),
    paddingTop: s('none'),
    paddingBottom: s('none'),
    boxSizing: 'border-box',
    overflow: 'hidden',
    alignItems: 'center',
  },
  '& .MuiTablePagination-toolbar': {
    minHeight: `${componentSizes.dataGrid.footerHeight}px`,
    height: `${componentSizes.dataGrid.footerHeight}px`,
    maxHeight: `${componentSizes.dataGrid.footerHeight}px`,
    paddingLeft: s('xxs'),
    paddingRight: s('none'),
    paddingTop: 0,
    paddingBottom: 0,
    overflow: 'hidden',
    alignItems: 'center',
  },
  '& .MuiTablePagination-spacer': {
    flex: '1 1 100%',
  },
  '& .MuiTablePagination-selectLabel': {
    margin: 0,
    fontSize: '15px',
    lineHeight: 1.4,
    display: 'flex',
    alignItems: 'baseline',
  },
  '& .MuiTablePagination-input': {
    marginLeft: s('xs'),
    marginRight: s('xs'),
    fontSize: '15px',
    lineHeight: 1.4,
    display: 'flex',
    alignItems: 'baseline',
    transform: 'translateY(2px)',
  },
  '& .MuiTablePagination-select.MuiSelect-select': {
    fontSize: '15px',
    lineHeight: 1.4,
    display: 'flex',
    alignItems: 'baseline',
    transform: 'translateY(1px)',
  },
  '& .MuiTablePagination-selectIcon': {
    transform: 'translateY(0px)',
  },
  '& .MuiTablePagination-displayedRows': {
    marginLeft: s('sm'),
    marginRight: s('xs'),
    fontSize: '15px',
    lineHeight: 1.4,
    display: 'flex',
    alignItems: 'baseline',
  },
  '& .MuiTablePagination-actions': {
    marginLeft: s('sm'),
    gap: 0,
  },
  '& .MuiTablePagination-actions .MuiIconButton-root': {
    margin: 0,
    minWidth: s('2xl'),
    width: s('2xl'),
    height: s('2xl'),
    padding: s('none'),
  },
};
